// Fontaine M20 — number parsing/formatting shared by NumberInput (and the tests). en-GB grouping.

export const formatNumber = (n, decimals) =>
  n == null || Number.isNaN(n)
    ? ""
    : new Intl.NumberFormat("en-GB", { minimumFractionDigits: decimals ?? 0, maximumFractionDigits: decimals ?? 2 }).format(n);

/** "HK$9,000" → 9000 · "-1,250.75" → -1250.75 · "abc" → null */
export const parseNumber = (text) => {
  if (text == null) return null;
  const cleaned = String(text).replace(/[^\d.,-]/g, "").replace(/,/g, "");
  if (cleaned === "" || cleaned === "-" || cleaned === ".") return null;
  const n = Number(cleaned);
  return Number.isNaN(n) ? null : n;
};
